import TableHead from './tableHead';

export default TableHead;
